// Rehearsal schedules by festival year.
// 2026 corps Zoom dates live here (code). Later years start empty and are
// edited on /iabf/admin/rehearsal-recordings (stored on that year's
// config/rehearsal-recordings doc).
//
// Each block:
//   pieceKey  — recording key `${date}:${pieceKey}`; for 2026 also matches
//               dancer.aliceInWonderland.participating etc.
//   pieceName — display label.
//   start/end — Eastern Time, "HH:MM" (24h).
//   splits    — optional sub-schedule rendered on the dancer view.

const REHEARSALS_2026 = [
  {
    date: '2026-05-10',
    blocks: [
      {
        pieceKey: 'garlandWaltz',
        pieceName: 'Garland Waltz',
        start: '11:30',
        end: '12:30',
        splits: [
          { start: '11:30', end: '11:50', label: 'Beginner Flats / Men' },
          { start: '11:50', end: '12:10', label: 'Intermediate Leaders / Men' },
          { start: '12:10', end: '12:30', label: 'Pointe ladies' }
        ]
      }
    ]
  },
  {
    date: '2026-05-24',
    blocks: [
      { pieceKey: 'becoming', pieceName: 'Becoming', start: '11:00', end: '12:00' },
      { pieceKey: 'waltzOfHours', pieceName: 'Waltz of the Hours', start: '12:00', end: '13:00' }
    ]
  },
  {
    date: '2026-05-30',
    blocks: [
      { pieceKey: 'leJazzHot', pieceName: 'Le Jazz Hot', start: '11:30', end: '13:00' }
    ]
  },
  {
    date: '2026-05-31',
    blocks: [
      {
        pieceKey: 'aliceInWonderland',
        pieceName: 'Alice in Wonderland',
        start: '12:00',
        end: '13:00',
        splits: [
          { start: '12:00', end: '12:30', label: 'Pointe' },
          { start: '12:30', end: '13:00', label: 'Flat' }
        ]
      }
    ]
  },
  {
    date: '2026-06-06',
    blocks: [
      { pieceKey: 'becoming', pieceName: 'Becoming', start: '11:00', end: '12:00' },
      {
        pieceKey: 'garlandWaltz',
        pieceName: 'Garland Waltz',
        start: '12:00',
        end: '13:00',
        splits: [
          { start: '12:00', end: '12:20', label: 'Beginner Flats / Men' },
          { start: '12:20', end: '12:40', label: 'Intermediate Leaders / Men' },
          { start: '12:40', end: '13:00', label: 'Pointe ladies' }
        ]
      }
    ]
  },
  {
    date: '2026-06-07',
    blocks: [
      { pieceKey: 'aliceInWonderland', pieceName: 'Alice in Wonderland', start: '13:00', end: '14:00' }
    ]
  },
  {
    date: '2026-06-13',
    blocks: [
      { pieceKey: 'leJazzHot', pieceName: 'Le Jazz Hot', start: '11:00', end: '12:30' }
    ]
  },
  {
    date: '2026-06-20',
    blocks: [
      { pieceKey: 'becoming', pieceName: 'Becoming', start: '11:00', end: '12:00' }
    ]
  },
  {
    date: '2026-06-21',
    blocks: [
      {
        pieceKey: 'garlandWaltz',
        pieceName: 'Garland Waltz',
        start: '11:00',
        end: '12:20',
        splits: [
          { start: '11:00', end: '11:20', label: 'Pointe ladies' },
          { start: '11:20', end: '11:40', label: 'Beginner Flat' },
          { start: '11:40', end: '12:00', label: 'Intermediate Leaders' },
          { start: '12:00', end: '12:20', label: 'Men' }
        ]
      },
      { pieceKey: 'waltzOfHours', pieceName: 'Waltz of the Hours', start: '12:30', end: '13:30' }
    ]
  },
  {
    date: '2026-06-28',
    blocks: [
      { pieceKey: 'aliceInWonderland', pieceName: 'Alice in Wonderland', start: '11:00', end: '12:00' }
    ]
  }
]

export const IABF_REHEARSALS_BY_YEAR = {
  2026: REHEARSALS_2026
}

/** @deprecated Use rehearsalsForYear — 2026-only leftover. */
export const IABF_REHEARSALS = REHEARSALS_2026

export function pieceKeyFromName (name) {
  const slug = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug || 'piece'
}

export function normalizeRehearsalDays (raw) {
  if (!Array.isArray(raw) || !raw.length) {
    return []
  }
  return raw.map((day) => {
    const date = String((day && day.date) || '').trim()
    const blocks = Array.isArray(day && day.blocks) ? day.blocks : []
    return {
      date,
      blocks: blocks.map((b) => ({
        pieceKey: String((b && b.pieceKey) || pieceKeyFromName(b && b.pieceName)).trim(),
        pieceName: String((b && b.pieceName) || '').trim() || 'Piece',
        start: String((b && b.start) || '11:00').trim(),
        end: String((b && b.end) || '12:00').trim(),
        splits: Array.isArray(b && b.splits) ? b.splits : []
      })).filter(b => b.pieceKey && date)
    }
  }).filter(day => day.date && day.blocks.length)
}

/**
 * Schedule for a festival year. Firestore custom sessions win when present;
 * otherwise the hardcoded year list (2026) or empty.
 */
export function rehearsalsForYear (year, storedSessions) {
  const y = Number(year)
  const stored = normalizeRehearsalDays(storedSessions)
  if (stored.length) {
    return stored
  }
  return IABF_REHEARSALS_BY_YEAR[y] || []
}

export function yearHasHardcodedRehearsals (year) {
  return Array.isArray(IABF_REHEARSALS_BY_YEAR[Number(year)]) &&
    IABF_REHEARSALS_BY_YEAR[Number(year)].length > 0
}
